import { createSlice } from '@reduxjs/toolkit'
import { REHYDRATE } from 'redux-persist'

export const initialState = {
    loaded: false,
    login: null,
    'nav-expanded': null,
    'nav-collapsed': null,
    landing: null,
}

export const logoSlice = createSlice({
    name: 'settings/logo',
    initialState,
    reducers: {
        setLogos: (state, action) => {
            return { ...state, ...action.payload, loaded: true }
        },
        setLogo: (state, action) => {
            const { slot, url } = action.payload
            state[slot] = url
        },
    },
    extraReducers: (builder) => {
        // Same rationale as nameSlice: keep the persisted (cached) logo URLs
        // for the first paint, but force a re-fetch so a stale cache never
        // sticks around forever.
        builder.addCase(REHYDRATE, (state) => {
            state.loaded = false
        })
    },
})

export const { setLogos, setLogo } = logoSlice.actions

export default logoSlice.reducer
